module.exports = __webpack_public_path__ + "img/6D1616_E6CDBA_DE2B24_230F0F-256px.9361aba4.png";